var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<wb-edit-member-details class=\"wb-member-edit-section\" member=\"member\"></wb-edit-member-details>\n<hr/>\n<wb-edit-member-address class=\"wb-member-edit-section\" member=\"member\"></wb-edit-member-address>";
var id1="member/member-form/member_form.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../src/public/sdk-templates/member/member-form/member_form.html
// module id = 1255
// module chunks = 0